var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-button',{attrs:{"slot":"reference","size":"mini","type":"primary"},on:{"click":_vm.showHistoryLog},slot:"reference"},[_vm._v("Ιστορικό")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.historyHTML)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d2fa34","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/showHistoryButton.vue
// module id = null
// module chunks = 